import React from 'react';
import ReportEC from '@giro/shared-components/reportsEC/ReportEC.component';
import fetch from '@giro/shared-utils/fetch.util';
import useFetchHook from '@giro-pdv/hooks/useFetch.hook';
import dialogReceipt from '@giro-pdv/store/dialogReceipt';
import reports from '../store/reports';

const ReportsECScreen = () => {
  const users = useFetchHook(
    () => fetch('pdv/users', { method: 'GET', ms: 'REPORTS', auth: true }),
    { requestOnMount: true }
  );
  return (
    <ReportEC
      reports={reports}
      receiptAction={dialogReceipt.action.open}
      users={users}
      restrictOperator
    />
  );
};

export default ReportsECScreen;
